import { networkService as network } from '@/services'

export const exhibitorEventMessangersService = {
  getMessangers(exhibitorEventId) {
    return new Promise((resolve, reject) => {
      network
        .get(`/exhibitor-event-messangers/${exhibitorEventId}`)
        .then((data) => {
          resolve(data.data)

        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updateMessanggers(exhibitorEvent, messangers) {
    const paylaoad = Object.assign({}, { ...messangers }, { exhibitorEvent });
    paylaoad.skype = paylaoad.skype === '' ? null : paylaoad.skype;
    paylaoad.zoom = paylaoad.zoom === '' ? null : paylaoad.zoom;
    paylaoad.meet = paylaoad.meet === '' ? null : paylaoad.meet;

    return new Promise((resolve, reject) => {
      network
        .put('/exhibitor-event-messangers/', paylaoad)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },
}